import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LegalPage.css";

const TermsOfService = ({ sidebarOpen }) => {
  const navigate = useNavigate();

  return (
    <main className={`legal-container ${sidebarOpen ? "sidebar-open" : ""}`}>
      <article className="legal-card">
        <button type="button" className="legal-back" onClick={() => navigate(-1)}>
          Back
        </button>
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: May 6, 2026</p>

        <section>
          <h2>Using PrepRight</h2>
          <p>
            PrepRight helps you manage pantry items, recipes, meal plans, shopping lists, and cooking activity.
            You are responsible for the information you add and for using cooking, storage, expiry, and nutrition
            suggestions with your own judgment.
          </p>
        </section>

        <section>
          <h2>Your Account</h2>
          <p>
            Keep your login details private. You are responsible for activity on your account. If you believe your
            account has been accessed without permission, reset your password or contact support.
          </p>
        </section>

        <section>
          <h2>Your Content</h2>
          <p>
            You keep ownership of recipes, posts, pantry entries, and other content you add. By adding content, you
            allow PrepRight to store and display it so the app can provide its features.
          </p>
        </section>

        <section>
          <h2>Food and Health Information</h2>
          <p>
            PrepRight is not medical, nutritional, or food-safety advice. Check labels, allergens, expiry dates, and
            food handling guidance yourself before cooking or eating.
          </p>
        </section>

        <section>
          <h2>Service Changes</h2>
          <p>
            This is a test build, so data may be reset periodically and features may change. We may update these terms
            as the app evolves.
          </p>
        </section>
      </article>
    </main>
  );
};

export default TermsOfService;
